import { createApi } from '@reduxjs/toolkit/query/react'
import { rtkBaseQuery } from 'Src/api'

export const loginApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'loginApi',
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/login',
          method: 'POST',
          body: payload
        }
      },
      transformResponse: async (response, meta) => {
        const csrfToken = meta.response.headers.get('x-xsrf-token')
        await response
        return { ...response, csrfToken }
      }
    })
  })
})

export const { useLoginMutation } = loginApi

export default loginApi
